export default __webpack_public_path__ + "static/char-s-55-ja-61b29682fad44c0c3f849924beac387f.webp";